import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Errors, Form, Control } from 'forms/rrf';
import { Col, FormLabel, Row } from 'react-bootstrap';
import PageTitle from '../../../../common/page-title';
import RequiredInput from '../../../../common/form/elements/required-input';
import ArrowButton from '../../../../common/button-arrow';
import BackLink from '../../../../common/back-link/index';
import MultiSelect from '../../../../common/form/multi-select';
import { createStockIt, getStockIt, getStockItMeta, updateStockIt } from '../../../../../actions/stock-it';
import PointsManagementLevel from './points_management_level';
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker';
import ImageUpload from '../../../../common/form/elements/image-upload';
import { editOverride } from '../../../../../utils/objectivesEditOverride';
import EligibilityDropdowns from '../../eligibility-dropdowns';
import RequiredMultiSelect from '../../../../common/form/elements/required-multi-select';

import './styles.css';

class AddStockIts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groupValues: []
    };
  }

  UNSAFE_componentWillMount() {
    this.id = +this.props.match.params.id;
    this.edit = !Number.isNaN(this.id);
    this.props.dispatch(getStockItMeta());

    if (this.edit) {
      this.props.dispatch(getStockIt(this.id));
    } else {
      this.props.dispatch(actions.reset('deep.stock_it'));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.stock_it'));
  }

  createProductList = products => products.map(curr => ({
    label: `${curr.sku_name} ${curr.sku_code}`,
    value: curr.id
  }));

  onSubmit = (data) => {
    const {dispatch} = this.props;

    dispatch(actions.resetErrors('deep.stock_it'));

    if (this.edit) {
      dispatch(actions.submitFields('deep.stock_it', updateStockIt(this.id, data, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.stock_it', createStockIt(data, dispatch)));
    }
  };

  createGroupList = groups =>
    groups.map(curr => ({
      label: `${curr.name}`,
      value: curr.id
    }));

  handleGroupChange = (e) => {
    this.setState({ groupValues: e });
  };

  render() {
    const { formData } = this.props;
    const numberOfProducts = formData.product_ids.length;
    let levelsForm = 'Loading...';

    if (this.edit) {
      levelsForm = this.props.meta.levels && Object.keys(this.props.levels).length > 0 &&
        this.props.meta.levels.map(level => (
          <PointsManagementLevel
            key={level.id}
            id={level.id}
            name={level.name}
            nextLevel={level.next_level}
            isEdit={editOverride(this)}
            level={this.props.levels ? this.props.levels[level.id] : null}
            model={'deep.stock_it.stock_objectives_levels'}
            numberOfProducts={numberOfProducts}
          />
        ));
    } else {
      levelsForm = this.props.meta.levels &&
        this.props.meta.levels.map(level => (
          <PointsManagementLevel
            key={level.id}
            id={level.id}
            name={level.name}
            nextLevel={level.next_level}
            isEdit={editOverride(this)}
            model={'deep.stock_it.stock_objectives_levels'}
            numberOfProducts={numberOfProducts}
          />
        ));
    }

    return (
      <div className='container-fluid stock-it-form'>
        <Row>
          <Col md={12}>
            <BackLink href='/admin/objectives/stock-it'/>
            <PageTitle>{`${this.edit ? 'EDIT' : 'ADD'} STOCK IT ${(!Number.isNaN(this.id) ? `ID: ${this.id}` : '')}`}</PageTitle>
          </Col>
        </Row>
        <Col md={12}>
          <Row>
            <Form model='deep.stock_it' onSubmit={this.onSubmit} >
              <Errors className='errors' model='deep.stock_it'/>
              <Row>
                <Col md={12}>
                  <RequiredInput
                    label='Name'
                    tooltip='This name will display to the user in their store performance and points statement pages'
                    model='.name'
                    placeholder='Name'
                    controlId='stockItName'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <FormLabel>Description</FormLabel>
                    <Control.textarea
                      className="form-control"
                      model=".description"
                      rows="5"
                      placeholder="Description"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <FormLabel>Merchandising standard</FormLabel>
                    <Control.text
                      className="form-control"
                      model=".merchandising_standard"
                      placeholder="Merchandising standard"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <FormLabel>Sell out quantity</FormLabel>
                    <Control.text
                      className="form-control"
                      model=".sell_out_qty"
                      type="number"
                      min={1}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <FormLabel>Sell out quantity description</FormLabel>
                    <Control.text
                      className="form-control"
                      model=".sell_out_qty_description"
                      placeholder="Sell out quantity description"
                    />
                  </div>
                </Col>
              </Row>
              <EligibilityDropdowns
                mc_outlets={this.props.mcOutlets}
                abm_codes={this.props.abm_codes}
                wse_bands={this.props.wse_bands}
                groups={this.props.groups}
                postcodes={this.props.postcodes}
                sub_zones={this.props.sub_zones}
                zones={this.props.zones}
                model='stock_it'
              />
              <Row>
                <Col md={3}>
                  <h4>Eligible SKUs*</h4>
                </Col>
                <Col md={9}>
                  <div>
                    <RequiredMultiSelect
                      data={this.createProductList(this.props.products)}
                      value={this.props.savedProducts}
                      controlId="products"
                      model='deep.stock_it.product_ids'
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  {this.props.meta.groups && (
                    <MultiSelect
                      data={this.createGroupList(this.props.meta.groups) || []}
                      value={this.props.groups || this.state.groupValues}
                      model='deep.stock_it.groups'
                      controlId='group'
                      label='Eligible Groups'
                      placeholder='Select...'
                      onChange={this.handleGroupChange}
                      withAllOption
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="Start Date"
                    controlId="start_date"
                    disabled={editOverride(this)}
                    model="deep.stock_it.start_date"
                    value={this.props.startDate}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="End Date"
                    controlId="end_date"
                    model="deep.stock_it.end_date"
                    value={this.props.endDate}
                    required={false}
                  />
                </Col>
              </Row>
              <Row>
                <h4>Points management</h4>
              </Row>
              <Row>
                <Col md={12}>
                  {levelsForm}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredInput
                    label='Maximum points'
                    model='.maximum_points'
                    placeholder='Maximum points'
                    controlId='stockItMaximumPoints'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="Display From Date"
                    controlId="display_from_date"
                    model="deep.stock_it.display_from_date"
                    value={this.props.displayFromDate}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <RequiredDatePicker
                    label="Display To Date"
                    controlId="display_to_date"
                    model="deep.stock_it.display_to_date"
                    value={this.props.displayToDate}
                    required={false}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormLabel>Image*</FormLabel>
                  <ImageUpload
                    source={(formData.links && formData.links.image) ? formData.links.image : ''}
                    model='deep.stock_it.image'
                    sizeLimit={1024 * 1024}
                    type={['image/png', 'image/jpg', 'image/jpeg']}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <ArrowButton className='float-right' color='red' disabled={!this.props.formValid}>Save</ArrowButton>
                </Col>
              </Row>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.stock_it.$form.valid,
  formData: state.deep.stock_it,
  savedProducts: state.deep.stock_it.product_ids || [],
  products: state.stock_its.meta.products || [],
  merchandising_standards: state.stock_its.meta.merchandising_standards || [],
  groups: state.deep.stock_it.groups || [],
  abm_codes: state.deep.stock_it.abm_codes || [],
  wse_bands: state.deep.stock_it.wse_bands || [],
  postcodes: state.deep.stock_it.postcodes || [],
  sub_zones: state.deep.stock_it.sub_zones || [],
  zones: state.deep.stock_it.zones || [],
  startDate: state.deep.stock_it.start_date || '',
  endDate: state.deep.stock_it.end_date || '',
  mcOutlets: state.deep.stock_it.mc_outlets || null,
  currentDateBeforeStartDate: state.deep.stock_it.current_date_before_start_date || false,
  displayFromDate: state.deep.stock_it.display_from_date || '',
  displayToDate: state.deep.stock_it.display_to_date || '',
  levels: state.deep.stock_it.levels || [],
  meta: state.stock_its.meta,
  fetching: state.stock_its.fetching,
  fetched: state.stock_its.fetched
});

export default connect(mapStateToProps)(AddStockIts);
